export default "__VITE_ASSET__C5xjO8aU__"